module.exports = __webpack_public_path__ + "img/20220420144212.185bfc91.png";